// extracted by mini-css-extract-plugin
module.exports = {"features":"_02712f2b3b--features--iH2Hk","left":"_02712f2b3b--left--O_J83","right":"_02712f2b3b--right--q25g_"};